<template>
  <div class="about-magazines">
    <image-aside-slide
      class="koldun-aside-slide"
      v-if="stylegoldWithKoldunImage"
      v-bind:tag="'div'"
      v-bind:image-src="stylegoldWithKoldunImage.image"
      v-bind:image-alt="stylegoldWithKoldunImage.alt_text"
      v-bind:preferred-image-position="'right'"
      v-bind:auto-full-screen="false"
    >
      <div class="text-block">
        <p>
          Вадим никогда не стремился создавать большие коллекции, отдавая
          предпочтение индивидуальности собственных изделий. Каждая новая
          модель – это результат долгого, кропотливого творческого поиска,
          на который уходит порой до нескольких месяцев. В своих творческих
          работах Вадим стремится к упрощению форм настолько, насколько это
          возможно. Следование данной цели всегда связано с многочасовыми
          раздумьями, поскольку создание нового изделия средствами простых
          форм всегда является особенно трудной задачей. Источником
          вдохновения может послужить все, что угодно – от морской волны до
          небрежно завязанного шарфа на шее проходящей мимо незнакомки.
        </p>
      </div>
    </image-aside-slide>
    <div class="baltic-way-magazine">
      <about-team-image-carousel
        v-bind:images="balticWayMagazineImages"
      ></about-team-image-carousel>
    </div>
    <div class="about-photography">
      <div class="text-block">
        <p>
          Фотография – это особенное увлечение для Вадима. В этом деле ему
          зачастую помогает его сын, Илья, который придумывает сюжеты будущих
          художественных фотографий ювелирных изделий и помогает Вадиму в
          процессе съемки. Художественные фотографии и неповторимый дизайн
          украшений Вадима Качана не раз привлекали внимание зарубежной прессы
          как в Европе так и в странах арабского региона. Их можно увидеть на
          страницах журналов в одном ряду с такими известными в мире брендами,
          как
          <a href="https://www.annamariacammilli.com/"
             target="_blank"
             rel="noopener noreferrer">Annamaria Cammilli</a>
          и
          <a href="https://degrisogono.com/"
             target="_blank"
             rel="noopener noreferrer">de Grisogono</a>
          и др.
        </p>
      </div>
    </div>
    <div class="pan-arab-magazine">
      <about-team-image-carousel
        v-bind:images="panArabMagazineImages"
      ></about-team-image-carousel>
    </div>
  </div>
</template>

<script>
import AboutTeamImageCarousel from './about-team/AboutTeamImageCarousel'
import ImageAsideSlide from './utils/ImageAsideSlide'

export default {
  name: 'AboutTeamVadimMagazines',
  props: [
    'stylegold-with-koldun-image',
    'baltic-way-magazine-images',
    'pan-arab-magazine-images'
  ],
  components: {AboutTeamImageCarousel, ImageAsideSlide},
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  @mixin half-page-flex-item {
    @include media (">tablet") { flex-basis: 50%; }
    @include media ("<=tablet") { flex-basis: 100%; }
  }

  .about-magazines {
    .text-block {
      @include text-block();
    }
    & > .koldun-aside-slide {
      background-color: $active-link-color;
      color: $default-background-color;
    }
    & > .baltic-way-magazine {
      background-color: $content-background-color;
      @include page-block-vertical-padding();
      @media only print {
        page-break-before: always;
        page-break-after: always;
      }
    }
    & > .about-photography {
      background-color: $inverse-background-color;
      color: $inverse-text-color;
      @include page-block-vertical-padding();
      a {
        font-weight: bold;
        color: $inverse-text-color;
        &:hover { color: $default-text-color; }
      }
    }
    & > .pan-arab-magazine {
      background-color: #eee;
      padding-top: 2em;
      padding-bottom: 3em;
      & >>> .carousel .slick-dots li button:before {
        color: $default-background-color;
      }
      & >>> .slick-prev:before,
      & >>> .slick-next:before {
        color: $default-background-color;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/AboutTeamVadimMagazines.vue